export const ENROLL_ACTION_QUERY_PARAM = "action";

export enum EnrollAction {
    CREATE_CLIENT = "createClient",
}

export interface EnrollActionProps {
    action?: EnrollAction;
}

export const BILLING_SETUP_REQUIRED_MESSAGE =
    "Ask your organization owner to set up billing before adding clients";

export const ENROLL_TO_ADD_CLIENTS_MESSAGE =
    "Set up billing to start adding clients.";
